import { Injectable, signal } from '@angular/core';
import { ToastMessage } from '../model/tops.models';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private nextId = 1;
  readonly messages = signal<ToastMessage[]>([]);

  show(message: Omit<ToastMessage, 'id'>): void {
    const toast: ToastMessage = { id: this.nextId++, variant: 'default', ...message };
    this.messages.update((items) => [toast, ...items].slice(0, 3));
    window.setTimeout(() => this.dismiss(toast.id), message.variant === 'destructive' ? 8000 : 4000);
  }

  success(title: string, description?: string): void {
    this.show({ title, description, variant: 'default' });
  }

  error(title: string, description?: string): void {
    this.show({ title, description, variant: 'destructive' });
  }

  dismiss(id: number): void {
    this.messages.update((items) => items.filter((item) => item.id !== id));
  }
}
